// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"445e18a028593fd0cb69","293":"293c3c3e5c38ed5c7120","518":"e9e552629ce77de089fb","779":"a5445bae8dda63220b45"}[chunkId] + ".js";
};